import objectPath from 'object-path'

const getRuleRequireTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleRequireMessage = (action = {}, value) => {
  let requireMessage =
    value !== undefined && value !== null
      ? value
      : action.value ||
        action.message ||
        objectPath.get(action, 'isRequire.requireMessage') ||
        true

  if (
    typeof requireMessage === 'string' &&
    requireMessage.trim() === ''
  ) {
    return true
  }
  return requireMessage
}

const setRuleRequireUiChanged = (
  designContext = {},
  target,
  status = {},
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  objectPath.set(isUiChanged, target, {
    isRender: true,
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

export const onRuleRequire = (
  designContext = {},
  action = {},
  status = {},
  valueOrOptions,
  target = '',
) => {
  let { elementAction = {}, setElementAction } = designContext
  let isOptions =
    valueOrOptions &&
    typeof valueOrOptions === 'object' &&
    (valueOrOptions.getRuleActionValue || objectPath.has(valueOrOptions, 'target'))
  let options = isOptions ? valueOrOptions : {}
  let value =
    options.getRuleActionValue
      ? options.getRuleActionValue(designContext, action, status)
      : valueOrOptions
  target = options.target || target
  let targetKey = getRuleRequireTarget(action, target)
  if (!targetKey) return undefined

  let requireMessage = getRuleRequireMessage(action, value)
  let requireOnSubmit = action.mode === 'onSubmit'

  if (requireOnSubmit) {
    objectPath.set(elementAction, ['requireOnSubmit', targetKey], requireMessage)
  } else {
    objectPath.set(elementAction, ['isRequire', targetKey], requireMessage)
  }
  setRuleRequireUiChanged(designContext, targetKey, status)
  if (setElementAction) setElementAction(elementAction)
  return requireMessage
}
